export const hasClass = (el, cls) => {
    if (el === null || el === undefined) {
        return false;
    }
    return el.className.length > 0 && new RegExp('(\\s|^)' + cls + '(\\s|$)').test(el.className);
};
export const addClass = (el, cls) => {
    if (el === null || el === undefined) {
        return;
    }
    if (el.classList) {
        el.classList.add(cls);
    }
    else {
        el.className += ' ' + cls;
    }
};
export const removeClass = (el, cls) => {
    if (el === null || el === undefined) {
        return;
    }
    if (el.classList) {
        el.classList.remove(cls);
    }
    else {
        el.className = el.className.replace(new RegExp('(^|\\b)' + cls.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
};
export const getParents = (el) => {
    const parents = [];
    let p = el.parentNode;
    while (p !== null) {
        const o = p;
        parents.push(o);
        p = o.parentNode;
    }
    return parents;
};
export const getParentWithClass = (el, cls) => {
    let parent = null;
    const parents = getParents(el);
    for (let i = 0; i < parents.length; i += 1) {
        if (hasClass(parents[i], cls)) {
            parent = parents[i];
            break;
        }
    }
    return parent;
};
